export class Permission {
    key: string;
    name: string;
    moduleKey: string;
    subName: string;
    subModuleKey: string;
    actionName: string; 
    actionKey: string;
    description: string;
}